import { render, staticRenderFns } from "./BookPickSendMain.vue?vue&type=template&id=ce6c4c5c&scoped=true&"
import script from "./BookPickSendMain.vue?vue&type=script&lang=js&"
export * from "./BookPickSendMain.vue?vue&type=script&lang=js&"
import style0 from "./BookPickSendMain.vue?vue&type=style&index=0&id=ce6c4c5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6c4c5c",
  null
  
)

export default component.exports